<template>
  <b-modal ref="modal" hide-footer centered title="Available applications" size="lg">
    <div class="d-flex justify-content-center mb-3" v-if="!loaded">
      <b-spinner label="Loading..." variant="primary"></b-spinner>
    </div>
    <div class="templateSelector">
      <div
        v-for="(template, key) in templateDescriptions"
        :key="key"
      >
        <b-card
          no-body
          @click="select(key)"
          :class="{ _installed: selectedTemplates.includes(key) }"
        >
          <b-card-body>
            <div
              class="templateSelector__img"
              :style="{ backgroundImage: `url(${template.img || placeholderImg})` }"
            >
            </div>
            <h4 class="card-title" v-if="template.name">{{ template.name }}</h4>
            <div class="card-text" v-if="template.desc">{{ template.desc }}</div>
            <b-badge
              variant="success"
              class="templateSelector__installedMarker"
              v-if="selectedTemplates.includes(key)"
            >
              Installed
            </b-badge>
          </b-card-body>
        </b-card>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
// services
import db from '@/services/db'
// helpers
import eventBus from '@/helpers/event-bus'

import placeholderImg from '@/assets/imgs/placeholder.png'

export default {
  props: ['templates', 'selected'],
  data () {
    return {
      inProcess: false,
      templateDescriptions: {},
      selectedTemplates: [],
      loaded: false
    }
  },
  computed: {
    ...mapState([
      'currentDash'
    ]),
    placeholderImg() {
      return placeholderImg || ''
    }
  },
  methods: {
    open() {
      if (this.$refs.modal) this.$refs.modal.show()

      this.getData()
    },
    select(dashKey) {
      if (this.selectedTemplates.includes(dashKey)) return

      eventBus.$emit('onBefore_inheritedTemplateAdded')

      db.dashboards.updateSelectedTemplates({ [dashKey]: true })
        .then(() => {
          eventBus.$emit('on_inheritedTemplateAdded')
        })
    },
    getData() {
      db.dashboards.getSelectedTemplates()
        .then(selectedTemplates => {
          this.selectedTemplates = selectedTemplates
        })

      const templateDescriptions = {}
      const queue = []

      for (let template of this.templates) {
        if (template === this.currentDash) continue

        queue.push({
          name: template,
          promise: new Promise(async resolve => {
            let templateDescription = {}

            await new Promise(r => {
              db.root.ref('dashboards')
                .child(template)
                .child('name')
                .once('value', snapshot => {
                  templateDescription.name = snapshot.val()
                  r()
                })
            })

            await new Promise(r => {
              db.root.ref('dashboards')
                .child(template)
                .child('templateDescription')
                .once('value', snapshot => {
                  const { desc, img } = snapshot.val() || {}

                  templateDescription = Object.assign(templateDescription, { desc, img })
                  r()
                })
            })

            templateDescriptions[template] = templateDescription
            resolve()
          })
        })
      }

      this.$loadingQueue(queue, () => {
        this.templateDescriptions = templateDescriptions
        this.loaded = true
      })
    }
  }
}
</script>

<style lang="scss">
@import '~$scss/globals';

.templateSelector {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  margin: 0 -6px;
  padding-bottom: 10px;
  > div {
    width: 33.333%;
    padding: 3px 6px;
    @include breakpoint(max-width $screenSm) {
      width: 50%;
    }
  }
  .card {
    height: calc(100% - 6px);
    max-width: 215px;
    margin-bottom: 0;
    transition: transform .3s;
    margin: {
      left: auto;
      right: auto;
    }
    &:hover {
      transform: scale(1.05);
      cursor: pointer;
    }
    &._installed:hover {
      transform: scale(1);
      cursor: default;
    }
    &-body {
      padding: {
        left: 15px;
        right: 15px;
        top: 10px;
        bottom: 20px;
      }
    }
    &-title {
      padding: 0;
      font-size: 14px;
      margin-bottom: 10px;
    }
    &-text {
      font-size: 12px;
    }
  }
  &__img {
    width: 100%;
    height: 150px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    margin-bottom: 5px;
  }
  &__installedMarker {
    position: absolute;
    left: 25px;
    top: 20px;
  }
}
</style>
